import router from './router'
import buildHost from './request/buildHost'
import { JIKE_WEB_HOST } from './request/host'

export const DEFAULT_REDIRECT_URL = '/following'

export function isValidRedirectURL(redirectURL: string) {
	if (!redirectURL.startsWith('/') || redirectURL.startsWith('//')) {
		return false
	}

	try {
		const url = new URL(redirectURL, buildHost(JIKE_WEB_HOST))
		const matches = router.matchRoutes(url.pathname, Object.fromEntries(url.searchParams), {
			throwOnError: false,
		})

		return matches.length > 0
	} catch {
		return false
	}
}

export function normalizeRedirectURL(redirectURL: string | null | undefined) {
	if (!redirectURL || !isValidRedirectURL(redirectURL)) {
		return DEFAULT_REDIRECT_URL
	}

	return redirectURL
}

export function getCurrentRedirectURL() {
	const url = new URL(window.location.href)

	return normalizeRedirectURL(`${url.pathname}${url.search}${url.hash}`)
}
